export default __webpack_public_path__ + "static/media/devices.dc2a257f.png";